<template>
  <div class="vx-col w-full md:w-1/1">
    <div class="h-screen flex w-full bg-img">
      <div
        class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
      >
        <img
          src="@/assets/images/pages/graphic-1.png"
          alt="graphic-404"
          class="mx-auto mb-4 max-w-full"
        >
        <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">
          Não há avisos no momento...
        </h1>
        <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text">
          Aqui você poderá acompanhar o mural de avisos virtual e ficar por dentro das novidades
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>
